import { makeStyles, type Theme } from '@material-ui/core/styles';

import { type RotateDirection, transformFromRotateDirection } from 'src/data/ui';

interface StyleProps {
  direction: RotateDirection;
}

export const useStyles = makeStyles<Theme, StyleProps>(
  (theme) => ({
    root: {
      transform: ({ direction }) => transformFromRotateDirection(direction),
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.short,
      }),
    },
  }),
  { name: 'ChevronIcon' }
);
